const UNITS = {
  s: 1_000,
  m: 60 * 1_000,
  h: 60 * 60 * 1_000,
  d: 24 * 60 * 60 * 1_000
}

/**
 * Parse a duration string into milliseconds.
 * Accepts: bare number (seconds), or number + unit suffix (s/m/h/d), or "never".
 * @param {string} input
 * @returns {number} milliseconds, or Infinity for "never"
 * @throws if input is invalid
 */
export function parseDuration(input) {
  if (typeof input !== 'string' || input === '') {
    throw new Error(`parseDuration: invalid input ${JSON.stringify(input)}`)
  }
  if (input === 'never') return Infinity

  const match = input.match(/^(\d+)([smhd])?$/)
  if (!match) {
    throw new Error(`parseDuration: cannot parse ${JSON.stringify(input)}`)
  }
  const value = Number(match[1])
  const unit = match[2] ?? 's'
  return value * UNITS[unit]
}
